/**
 * Created by tombray on 11/24/14.
 */
var interceptor = require('rest/interceptor');
var when = require('when');

export default interceptor({

    request: function(request){
        return request;
    },

    response: function(response, config) {

        if (response.entity && response.entity.success === false) {
            return when.reject(response);
        }
        return when(response);
    }
});
